module.exports = __webpack_public_path__ + "static/media/Billingactive.1d5067ef.png";